import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { caseVoucherCategoryOrder, } from '@debbie/common/dist/economy/case-vouchers';
import helpers from '@debbie/common/dist/economy/helpers';
import { selectTenant } from '@debbie/cortex/dist/me/selectors';
import THEME from '../../../theme';
import { sum } from '../../../utils';
import Money from '../../Money';
import Group from './Group';
const CaseVouchers = (props) => {
    const tenant = useSelector(selectTenant);
    const lang = useSelector((s) => s.lang);
    const [depositCaseVoucherHovored, setDepositCaseVoucherHovored] = useState(null);
    const voucherChildren = {};
    helpers.vouchers
        .postProcessing(props.caseVouchers, {
        includeExpiredVouchers: false,
        includeDeletedVouchers: false,
        includeIrrecoverableVouchers: false,
    })
        .forEach((caseVoucher) => {
        const key = caseVoucher.referenceCaseVoucherId;
        if (key) {
            if (!voucherChildren[key]) {
                voucherChildren[key] = [];
            }
            voucherChildren[key].push(caseVoucher);
        }
    });
    const caseVouchers = props.caseVouchers
        .filter((caseVoucher) => {
        const validatedCaseVoucherRelations = caseVoucher.referenceCaseVoucherId == null ||
            props.caseVouchers.find((v) => v.caseVoucherId === caseVoucher.referenceCaseVoucherId) == null;
        const showExpiredCaseVouchers = !caseVoucher.expired ||
            (!props.hideExpiredCaseVouchers && caseVoucher.expired);
        return validatedCaseVoucherRelations && showExpiredCaseVouchers;
    })
        .map((v) => (Object.assign(Object.assign({}, v), { children: voucherChildren[v.caseVoucherId] || [] })))
        .sort((a, b) => {
        return (caseVoucherCategoryOrder.indexOf(a.category) -
            caseVoucherCategoryOrder.indexOf(b.category));
    });
    const categories = caseVouchers.reduce((acc, caseVoucher) => {
        if (!acc[caseVoucher.category]) {
            acc[caseVoucher.category] = { caseVouchers: [] };
        }
        acc[caseVoucher.category].caseVouchers.push(caseVoucher);
        return acc;
    }, {});
    const newCategories = {};
    Object.keys(categories).forEach((categoryName) => {
        const category = categories[categoryName];
        newCategories[categoryName] = {
            caseVouchers: category.caseVouchers.reduce((acc, voucher) => {
                if (acc[voucher.voucherTypeId]) {
                    acc[voucher.voucherTypeId].push(voucher);
                }
                else {
                    acc[voucher.voucherTypeId] = [voucher];
                }
                return acc;
            }, {}),
            sum: category.caseVouchers
                .filter((caseVoucher) => !caseVoucher.deletedAt)
                .map((v) => v.amount +
                v.children
                    .filter((c) => c.category === v.category)
                    .map((c) => c.amount)
                    .reduce(sum, 0))
                .reduce(sum, 0),
        };
    });
    const categoriesArr = Object.values(categories);
    // Hide categories if there is only a single
    const hideCategories = categoriesArr.reduce((acc, category) => {
        if (!acc)
            return acc;
        const voucherTypes = Object.keys(category.caseVouchers);
        if (voucherTypes.length > 1)
            return false;
        return acc;
    }, true) || categoriesArr.length === 1;
    const accountSum = caseVouchers
        .filter((caseVoucher) => !caseVoucher.deletedAt)
        .map((v) => {
        const childrenSum = v.children
            .filter((caseVoucher) => !caseVoucher.deletedAt)
            .map((v) => v.amount)
            .reduce(sum, 0);
        return v.amount + childrenSum;
    })
        .reduce(sum, 0);
    const isTenantBaseCurrency = !!((tenant && tenant.currency) === props.singleCase.currency);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: {
                textAlign: 'right',
                margin: '-5px 0 -5px 0',
            } },
            React.createElement(Currency, { isTenantBase: isTenantBaseCurrency }, props.singleCase.currency)),
        Object.keys(newCategories).map((category) => (React.createElement(Wrapper, { key: category },
            React.createElement(Group, { small: false, caseVouchers: caseVouchers, category: category, newCategories: newCategories, collapseGroup: hideCategories, singleCase: props.singleCase, setDepositCaseVoucherHovored: setDepositCaseVoucherHovored, depositCaseVoucherHovored: depositCaseVoucherHovored })))),
        !(categoriesArr.length === 1 &&
            Object.keys(categoriesArr[0].caseVouchers.reduce((acc, caseVoucher) => {
                acc[caseVoucher.voucherTypeId] = true;
                if (caseVoucher.children && caseVoucher.children.length > 0)
                    acc[caseVoucher.voucherTypeId + 'referenceCaseVouchers'] = true;
                return acc;
            }, {})).length <= 1) ? (React.createElement(StyledGroup, { parent: false, small: false },
            React.createElement(GroupHeader, null,
                React.createElement("div", { style: { display: 'flex', alignItems: 'center' } }, lang.economy.sum),
                React.createElement(Money, { amount: accountSum, color: true })))) : null));
};
export default CaseVouchers;
const StyledGroup = styled.div `
  margin: 0;
  padding: ${(props) => props.small
    ? '0em 0 0.5em 0em'
    : props.parent
        ? '0.5em 0 0.2em 0em'
        : '0.5em 0 0.5em 0em'};
  font-size: ${(props) => (props.small ? '0.8em' : '1em')};
`;
const GroupHeader = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 900;
`;
const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
`;
const Currency = styled.div `
  margin: -5px 0 -5px 0;
  padding: ${(props) => (props.isTenantBase ? '0px 0px' : '0px 4px')};
  font-weight: 900;
  font-size: 0.8em;
  display: inline-block;
  color: ${(props) => props.isTenantBase ? THEME.COLOR_PRIMARY : THEME.COLOR_SECONDARY};
  background-color: ${(props) => props.isTenantBase ? 'inherit' : THEME.COLOR_ACCENT};
  border-radius: 3px;
`;
//# sourceMappingURL=CaseVouchers.js.map